import { DocumentViewerDialog } from '@/components/feedback/DocumentViewerDialog';

import { InviteSignersDialog } from './InviteSignersDialog';
import { PayItemDialog } from './PayItemDialog';
import { SignItemDialog } from './SignItemDialog';
import type { ItemDialogsState } from './useItemDialogs';

/** Renders whichever item dialog `useItemDialogs` says is open. */
export const ItemDialogs = ({ state }: { state: ItemDialogsState }) => {
  const { current, close } = state;
  if (current === undefined) return null;

  if (current.kind === 'document') {
    return (
      <DocumentViewerDialog
        open
        onClose={close}
        source={current.source}
        title={current.title}
      />
    );
  }

  if (current.kind === 'pay') return <PayItemDialog item={current.item} onClose={close} />;
  if (current.kind === 'sign') return <SignItemDialog item={current.item} onClose={close} />;
  return <InviteSignersDialog item={current.item} onClose={close} />;
};
